import { addDays, differenceInCalendarDays, format, parseISO } from "date-fns";

export const CALENDAR_DAY_WIDTH = 80;

interface CalendarItemDates {
  start_position: number;
  width: number;
  start_date?: string | null;
  end_date?: string | null;
}

export function calendarDateString(date: Date): string {
  return format(date, "yyyy-MM-dd");
}

export function calendarDatesFromPosition(startPosition: number, width: number, today = new Date()) {
  const start = addDays(today, Math.floor(startPosition / CALENDAR_DAY_WIDTH));
  const end = addDays(start, Math.max(1, Math.ceil(width / CALENDAR_DAY_WIDTH)));
  return { start_date: calendarDateString(start), end_date: calendarDateString(end) };
}

export function calendarDatesFromSelection(startDate: string, duration: number, today = new Date()) {
  const start = parseISO(startDate);
  const days = Math.max(1, Math.ceil(duration));
  return {
    start_date: startDate,
    end_date: calendarDateString(addDays(start, days)),
    start_position: differenceInCalendarDays(start, today) * CALENDAR_DAY_WIDTH,
    width: days * CALENDAR_DAY_WIDTH,
  };
}

// Stored positions are relative to the day they were saved, not necessarily today.
// Apply drag deltas to the authoritative absolute date, then refresh storage offsets.
export function calendarDatesFromDrag(item: CalendarItemDates, position: number, width: number, today = new Date()) {
  const original = item.start_date ?? calendarDatesFromPosition(item.start_position, item.width, today).start_date;
  const deltaDays = Math.round((position - item.start_position) / CALENDAR_DAY_WIDTH);
  const start = calendarDateString(addDays(parseISO(original), deltaDays));
  return calendarDatesFromSelection(start, width / CALENDAR_DAY_WIDTH, today);
}